import React, { useRef } from 'react'

import { HostServices } from '@ally/federated-types'
import { Router as ReactRouter } from 'react-router-dom'
import { muiBankTheme, MetronomeProvider } from '@ally/metronome-ui'
import ErrorBoundary from '@ally/next-remote-error-boundary'
import { once } from '@ally/utilitarian'

import Router from './routes'
import { HostServicesContext } from './HostServices'

interface AppProps {
  services: HostServices
}

const App: React.FC<AppProps> = ({ services }) => {
  const name = 'account-details'
  const { browserHistory } = services

  // Temporary fix to preserve path and query BEFORE the redirectors happen
  // This will eventually be replaced by a more permanent solution in Ally Next
  const { current: requireAuth } = useRef(
    once(() => {
      const redirect = encodeURIComponent(
        `${window.location.pathname}${window.location.search}`,
      )
      services.session.requireAuth(redirect)
    }),
  )
  requireAuth()

  return (
    <ReactRouter history={browserHistory}>
      <MetronomeProvider theme={muiBankTheme}>
        <HostServicesContext.Provider value={services}>
          <ErrorBoundary hostServices={services} name={name}>
            <Router />
          </ErrorBoundary>
        </HostServicesContext.Provider>
      </MetronomeProvider>
    </ReactRouter>
  )
}

export default App
